import { useQuery } from '@tanstack/react-query';
import useBookingMinimalShop from './use-booking-minimal-shop';
import { loadBookingShop } from './data-loaders/shop-loader';
import useLocale from '../../../Hooks/use-locale';

const useBookingShop = (enabled: boolean = true) => {
  // We intentionally use minimalShop.id here to defer the query until minimalShop is loaded
  const { data: minimalShop } = useBookingMinimalShop(enabled);
  const { languageAsEnum } = useLocale();

  return useQuery({
    queryKey: ['bookingShop', minimalShop?.id, languageAsEnum],
    queryFn: () => loadBookingShop(minimalShop?.id ?? '', languageAsEnum),
    enabled: enabled && Boolean(minimalShop?.id),
  });
};

export default useBookingShop;
